import React from 'react';

export const Xls = props => (
  <svg
    width="36"
    height="38"
    viewBox="0 0 36 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_2613_7941)">
      <rect
        x="1.59961"
        y="0.800049"
        width="32"
        height="32"
        rx="8"
        fill="url(#paint0_linear_2613_7941)"
      />
      <rect
        x="1.99961"
        y="1.20005"
        width="31.2"
        height="31.2"
        rx="7.6"
        stroke="white"
        strokeWidth="0.8"
      />
      <path
        d="M5.75879 16.4004H29.4395C29.894 16.4004 30.2113 16.4007 30.458 16.4209C30.6998 16.4407 30.8391 16.4776 30.9443 16.5312C31.1699 16.6463 31.3538 16.83 31.4688 17.0557C31.5223 17.1609 31.5594 17.3003 31.5791 17.542C31.5992 17.7886 31.5996 18.1054 31.5996 18.5596V20.96C31.5996 22.7587 31.5992 24.0837 31.5137 25.1309C31.4285 26.1733 31.2606 26.9057 30.9453 27.5244C30.3701 28.6532 29.4521 29.5713 28.3232 30.1465C27.7045 30.4617 26.9721 30.6287 25.9297 30.7139C24.8826 30.7994 23.5573 30.7998 21.7588 30.7998H13.4395C11.6408 30.7998 10.3157 30.7994 9.26855 30.7139C8.22608 30.6287 7.49373 30.4617 6.875 30.1465C5.74614 29.5713 4.82817 28.6532 4.25293 27.5244C3.93767 26.9057 3.77072 26.1733 3.68555 25.1309C3.59999 24.0837 3.59961 22.7587 3.59961 20.96V18.5596C3.59961 18.1053 3.59999 17.7886 3.62012 17.542C3.63988 17.3001 3.67684 17.161 3.73047 17.0557C3.84552 16.8299 4.02909 16.6463 4.25488 16.5312C4.3602 16.4776 4.49928 16.4407 4.74121 16.4209C4.98783 16.4008 5.30454 16.4004 5.75879 16.4004Z"
        fill="url(#paint1_linear_2613_7941)"
        stroke="#217346"
        strokeWidth="0.8"
      />
      <path
        d="M3.19922 12.64C3.19922 13.536 3.19922 13.9841 3.37361 14.3263C3.52701 14.6274 3.77177 14.8722 4.07283 15.0256C4.41509 15.2 4.86313 15.2 5.75922 15.2H29.4392C30.3353 15.2 30.7833 15.2 31.1256 15.0256C31.4267 14.8722 31.6714 14.6274 31.8248 14.3263C31.9992 13.9841 31.9992 13.536 31.9992 12.64C31.9992 9.05562 31.9992 7.26345 31.3017 5.89441C30.6881 4.69018 29.709 3.7111 28.5048 3.09751C27.1357 2.39995 25.3436 2.39995 21.7592 2.39995H13.4392C9.85488 2.39995 8.06272 2.39995 6.69368 3.09751C5.48944 3.7111 4.51037 4.69018 3.89678 5.89441C3.19922 7.26345 3.19922 9.05562 3.19922 12.64Z"
        fill="url(#paint2_linear_2613_7941)"
      />
      <g filter="url(#filter1_di_2613_7941)">
        <path
          d="M11.3016 20.6L12.4704 22.6219H12.5204L13.7016 20.6H15.4329L13.5016 23.8L15.4954 27H13.7204L12.5204 24.9562H12.4704L11.2704 27H9.50785L11.4922 23.8L9.55785 20.6H11.3016ZM16.1229 27V20.6H17.6697V25.7437H20.3322V27H16.1229ZM24.4824 22.5187C24.4615 22.2896 24.3688 22.1115 24.2043 21.9844C24.0418 21.8552 23.8095 21.7906 23.5074 21.7906C23.3074 21.7906 23.1407 21.8167 23.0074 21.8687C22.874 21.9208 22.774 21.9927 22.7074 22.0844C22.6407 22.174 22.6063 22.2771 22.6043 22.3937C22.6001 22.4896 22.6188 22.574 22.6605 22.6469C22.7043 22.7198 22.7668 22.7844 22.848 22.8406C22.9313 22.8948 23.0313 22.9427 23.148 22.9844C23.2647 23.026 23.3959 23.0625 23.5418 23.0937L24.0918 23.2187C24.4084 23.2875 24.6876 23.3792 24.9293 23.4937C25.173 23.6083 25.3772 23.7448 25.5418 23.9031C25.7084 24.0615 25.8345 24.2437 25.9199 24.45C26.0053 24.6562 26.049 24.8875 26.0511 25.1437C26.049 25.5479 25.947 25.8948 25.7449 26.1844C25.5428 26.474 25.2522 26.6958 24.873 26.85C24.4959 27.0042 24.0407 27.0813 23.5074 27.0813C22.972 27.0813 22.5053 27.001 22.1074 26.8406C21.7095 26.6802 21.4001 26.4365 21.1793 26.1094C20.9584 25.7823 20.8449 25.3687 20.8386 24.8687H22.3199C22.3324 25.075 22.3876 25.2469 22.4855 25.3844C22.5834 25.5219 22.7178 25.626 22.8886 25.6969C23.0615 25.7677 23.2615 25.8031 23.4886 25.8031C23.697 25.8031 23.874 25.775 24.0199 25.7187C24.1678 25.6625 24.2813 25.5844 24.3605 25.4844C24.4397 25.3844 24.4803 25.2698 24.4824 25.1406C24.4803 25.0198 24.4428 24.9167 24.3699 24.8312C24.297 24.7437 24.1845 24.6687 24.0324 24.6062C23.8824 24.5417 23.6907 24.4823 23.4574 24.4281L22.7886 24.2719C22.2345 24.1448 21.798 23.9396 21.4793 23.6562C21.1605 23.3708 21.0022 22.9854 21.0043 22.5C21.0022 22.1042 21.1084 21.7573 21.323 21.4594C21.5376 21.1615 21.8345 20.9292 22.2136 20.7625C22.5928 20.5958 23.0251 20.5125 23.5105 20.5125C24.0063 20.5125 24.4365 20.5969 24.8011 20.7656C25.1678 20.9323 25.4522 21.1667 25.6543 21.4687C25.8563 21.7708 25.9595 22.1208 25.9636 22.5187H24.4824Z"
          fill="url(#paint3_linear_2613_7941)"
          shapeRendering="crispEdges"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_2613_7941"
        x="-0.000390768"
        y="4.88162e-05"
        width="35.2"
        height="37.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="0.8"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_2613_7941"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7941"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3.2"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_2613_7941"
        />
        <feOffset dy="3.2" />
        <feGaussianBlur stdDeviation="2.4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2613_7941"
          result="effect2_dropShadow_2613_7941"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2613_7941"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_2613_7941"
        x="9.50781"
        y="19.7125"
        width="16.543"
        height="8.16885"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.129412 0 0 0 0 0.45098 0 0 0 0 0.27451 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7941"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2613_7941"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.8" />
        <feGaussianBlur stdDeviation="0.8" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2613_7941"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2613_7941"
        x1="17.5996"
        y1="0.800049"
        x2="17.5996"
        y2="32.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2613_7941"
        x1="17.5992"
        y1="16"
        x2="17.5992"
        y2="31.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#217346" />
        <stop offset="1" stopColor="#2F8C59" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2613_7941"
        x1="17.5992"
        y1="2.39995"
        x2="17.5992"
        y2="15.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4F4F4" />
        <stop offset="1" stopColor="#F4F4F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2613_7941"
        x1="17.7998"
        y1="19.4667"
        x2="17.7998"
        y2="25.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);
